import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/app'
import { channels } from '@/translations/resources/cs/partials/channels'
import { deliveryTypeCategories } from '@/translations/resources/cs/partials/deliveryTypeCategories'
import { notificationTypes } from '@/translations/resources/cs/partials/notificationTypes'

export default {
    notification: {
        type: notificationTypes,
        title: {
            [NotificationType.PostponedOrder]: 'Aktualizace objednávky {{ orderShortCode }}',
        },
        body: {
            [NotificationType.PostponedOrder]:
                'Odložené objednávce {{ orderShortCode }} vypršel nastavený čas pro připomenutí',
        },
    },
    order: {
        channel: channels,
        deliveryTypeCategory: deliveryTypeCategories,
    },
}
